/* eslint react-hooks/rules-of-hooks: "warn" */
import { getHotkeyMenu, HOTKEY_TYPE, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;

    if (!layer) return null;

    const item = {
        name: $t((v) => v.contextMenuLayer.menu[layer.lock ? 'unLock' : 'lock']),
        type: HOTKEY_TYPE.lock,
        desc: getHotkeyMenu(HOTKEY_TYPE.lock),
        onClick: () => {
            framework.events.emit(HOTKEY_TYPE.lock);
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 3,
    sort: 4,
    render,
} as IExportContextMenuItem;
